window.calculatorCalculation = (P, r, n, t) => {
  r = r / 12 / 100;
  t = t * 12;
  const A = P * (((Math.pow(1 + r, t) - 1) / r) * (1 + r));
  const interestEarned = A - P * t;
  return { maturityAmount: P * t, interestEarned: interestEarned };
};
